import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlSanitizer',
})
export class HtmlSanitizerPipe implements PipeTransform {
  constructor() {}

  transform(value :string) :string {
    return value.replace(/<[^>]*>|&nbsp;/g, '');
  }
}
